export const postalCodePattern = {
  value: /^[1-9]\d{3}[A-Z]{2}$/i,
  message: 'Vul een geldige postcode in: 1234AB',
};
